import { giveAskStanleyFeedback } from '@/lib/api/askStanley';
import { stanAnalytics } from '@/lib';
import { ChatSession } from '../types/askStanley.types';

export interface GiveFeedbackParams {
    messageId: string | number;
    feedback: 1 | -1;
    currentChatId: string | number;
    chats: ChatSession[];
    user?: { user_id?: string | number; username?: string };
}

export interface GiveFeedbackCallbacks {
    onFeedbackUpdate: (messageId: string | number, feedback: number) => void;
    onError: (error: string) => void;
}

/**
 * Handles giving feedback on a message
 * Pure business logic - no direct store access
 */
export async function handleGiveFeedback(params: GiveFeedbackParams, callbacks: GiveFeedbackCallbacks): Promise<void> {
    const { messageId, feedback, currentChatId, chats, user } = params;
    const { onFeedbackUpdate, onError } = callbacks;

    const currentChat = chats.find(chat => chat.id === currentChatId);
    const message = currentChat?.messages.find(msg => msg.id === messageId);

    // Track feedback event (matching Vue event names)
    const eventName = feedback === 1 ? 'chat-v2-thumbs-up' : 'chat-v2-thumbs-down';
    stanAnalytics(eventName, {
        meta: { user_id: user?.user_id, username: user?.username },
        props: {
            message_id: messageId,
            feedback_value: feedback,
            message_type: message?.type || 'unknown',
            chat_id: currentChatId,
            platform: typeof window !== 'undefined' && window.innerWidth < 768 ? 'mobile' : 'desktop',
        },
    });

    try {
        await giveAskStanleyFeedback(messageId, feedback);
        onFeedbackUpdate(messageId, feedback);
    } catch (error) {
        console.error('Failed to submit feedback:', error);
        onError('Failed to submit feedback. Please try again.');
        throw error;
    }
}
